// @mui
// import { useTheme } from '@mui/material/styles';
import { Box, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

export default function MaintenanceIllustration({ ...other }: BoxProps) {
  // const theme = useTheme();
  // const PRIMARY_MAIN = theme.palette.primary.main;
  // const PRIMARY_DARKER = theme.palette.primary.darker;

  return <Box {...other} />;
}
